import { useEffect, useState } from 'react'
import { useImmer } from 'use-immer'
import { useDispatch } from "react-redux"
import { setAdditionalSubHdView, setSubHeading } from "../../store/reducers/CommonReducer"
import { setContentLoading } from "../../store/reducers/CommonReducer"
import { CC_PRODUCT_ID, TOKEN_2 } from "../../utils/Constants"
import { getSessionItem } from "../../utils/storageUtils"
import { SIP_URL } from "../../utils/Config"
import { getHTMLObject, getTranslated } from "../../utils/CommonUtils"
import { useSelector } from "react-redux"
import { Divider, Select, Button } from 'antd'
import UMCButton from '../common/UMCButton'
import { DARK_GRAY, PURPLE, } from "../../styles/styleUtils"
import InputField from "./InputField"
import TabExtraContent from '../common/TabExtraContent'
import parse from 'html-react-parser'
import CustomDialog from './CustomDialog'
import getData from './GetData'

//===================================
// VNA gateway parameters config page
//===================================

const VNATrunk = ({ onPrevious, onNext, activeProfile, trunkConfig, setTrunkConfig, configurationData, setConfigurationData }) => {
    const [errorsOnPage, setErrorsOnPage] = useState(0);

    const [workingSipTrunkConfig, setWorkingSipTrunkConfig] = useImmer({});

    // Dialog parameters
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dlgType, setDlgType] = useState();
    const [title, setTitle] = useState();
    const [message, setMessage] = useState();
    // Dialog footer button definition
    const [footer, setFooter] = useState([]);

    const dispatch = useDispatch();
    const dict = useSelector((state) => state.common.dict);
    const language = useSelector((state) => state.common.language);
    
    let errorsOnRedraw = errorsOnPage;

    const profileHandler = (data) => {
        setConfigurationData(data[0]);
    }

    useEffect(() => {
        dispatch(setSubHeading(getTranslated(dict, "LABEL_CREATE_TRUNK") + " : " + activeProfile.name));
    }, [dict]);

    useEffect(() => {
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()))
    }, [language]);

    useEffect(() => {
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()));

        const fetchData = async () => {
            var url, response;

            try {
                url = SIP_URL + "/sipprofile/params/" + activeProfile.id;

                dispatch(setContentLoading(true));
                response = await getData(url, null, profileHandler);
                dispatch(setContentLoading(false));
            }
            catch (e) {
                console.error(e);
                dispatch(setContentLoading(false));
            }
        };

        if (trunkConfig?.Profile !== undefined) {
            setWorkingSipTrunkConfig(trunkConfig);
        } else {
            fetchData();
        }
    }, []);

    // VNA SIP Trunk data handlers
    const updateTrunkGroupName = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VNA_Trunk_Data.Trunk_Group_Name = value; });
    }

    const updateIP = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VNA_Trunk_Data.Remote_CPU_1_IP_Address = value; });
    }
    
    // VNA SIP MASTER Trunk data handlers
    const updateMasterTrunkGroupName = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VNA_Master_Trunk_Data.Trunk_Group_Name = value; });
    }

    const updateMasterIP = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VNA_Master_Trunk_Data.Remote_CPU_1_IP_Address = value; });
    }

    // VNA SIP MASTER Trunk data handlers
    const updateSlaveTrunkGroupName = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VNA_Slave_Trunk_Data.Trunk_Group_Name = value; });
    }

    const updateSlaveIP = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_VNA_Slave_Trunk_Data.Remote_CPU_1_IP_Address = value; });
    }

    // Error handler (count errors on the page)
    const errorHandler = (value) => {

        if (value === true) {
            errorsOnRedraw++;
        }
        else {
            if (errorsOnPage > 0)
                errorsOnRedraw--;
        }
        setErrorsOnPage(errorsOnRedraw);
    }

    // Create JSON config for SIPtrunk
    function createTrunkConfig() {
        let obj = { Profile: {} };
        Object.keys(configurationData.Profile).forEach(group => {
            obj.Profile[group] = {};
            Object.keys(configurationData.Profile[group]).forEach(key => {
                if (configurationData.Profile[group][key]?.defaultValue !== undefined) {
                    obj.Profile[group][key] = configurationData.Profile[group][key].defaultValue;
                }
                else {
                    var value = configurationData.Profile[group][key];

                    if (Array.isArray(value)) {
                        obj.Profile[group][key] = [];
                    } 
                    else if (typeof value === 'object' && value !== null) {
                        obj.Profile[group][key] = {}; 
                        Object.keys(value).forEach(subKey => {
                            obj.Profile[group][key][subKey] = value[subKey].defaultValue;
                        })
                    }
                }
            })
        });
        return obj;
    }

    // Modal message handlers
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    // Previous button handler. The previous page is the profile selection so we have to erase the trunk config
    const onPreviousPage = () => {
        setTrunkConfig({});
        onPrevious();
    }

    // Validation handler for the page
    async function validateFields() {
        if (workingSipTrunkConfig?.Profile?.UI_VNA_Master_Ext_Gateway_Data?.SIP_Outbound_Proxy_User && workingSipTrunkConfig?.Profile?.UI_VNA_Slave_Ext_Gateway_Data?.SIP_Outbound_Proxy_User) {
            if (workingSipTrunkConfig?.Profile?.UI_VNA_Master_Ext_Gateway_Data?.SIP_Outbound_Proxy_User === workingSipTrunkConfig?.Profile?.UI_VNA_Slave_Ext_Gateway_Data?.SIP_Outbound_Proxy_User) {
                setDlgType("Error");
                setTitle(getTranslated(dict, "LABEL_SIP_TRUNK_CREATION_IMPOSSIBLE"));
                setMessage(getTranslated(dict, "MSG_SAME_TRUNK_NAME"));
                setFooter([
                    <Button key="ok" type="primary" onClick={handleOk} className="sip-modal-btn">
                        {getTranslated(dict, "LABEL_OK")}
                    </Button>,
                ]);
                errorsOnRedraw++;
                showModal(true);
            }
        }

        // Update the parent state
        setTrunkConfig(workingSipTrunkConfig);

        if (errorsOnRedraw === 0) {
            onNext();
        }
    }

    // Top right icons 
    const getExtraSubHeaderContent = () => {
        return <TabExtraContent
            contentItems={activeProfile.docRef ? ["document", "help"] : ["help"]}
            documentButtonText={activeProfile.docRef}
            handleDocument={() => {
                if (activeProfile.docUrl !== "")
                    window.open(`${activeProfile.docUrl}`, "_blank")
            }}
            handleHelpReq={() => {
                // code to handle help doc action
                let src = `/hol/oxe/oxe-${language}/dita/topics/umc_EN_DE_ES_FR/umc_easy-sip-trunk-creation.html`
                window.open(`${src}#Create-VNA__SIP-Parameters`, "_blank")
            }}
        />
    }

    if (configurationData?.Profile !== undefined && workingSipTrunkConfig?.Profile === undefined) {
        setWorkingSipTrunkConfig(createTrunkConfig());
    }

    return (<>
        {(() => {
            if (configurationData?.Profile?.UI_VNA_Trunk_Data !== undefined) {
                return (<div>
                    <Divider className="sip-header" orientation="left" orientationMargin="0" plain style={{ borderColor: DARK_GRAY, }}>
                        {getTranslated(dict, "LABEL_UI_VNA_TRUNK_DATA")}
                    </Divider>

                    { // Trunk name
                        configurationData?.Profile?.UI_VNA_Trunk_Data?.Trunk_Group_Name &&
                        <InputField label={getTranslated(dict, "PARAM_TRUNK_GROUP_NAME")}
                            defaultValue={configurationData?.Profile?.UI_VNA_Trunk_Data?.Trunk_Group_Name?.defaultValue}
                            regexp={configurationData?.Profile?.UI_VNA_Trunk_Data?.Trunk_Group_Name?.pattern}
                            handleChange={updateTrunkGroupName}
                            handleError={errorHandler}
                            value={trunkConfig?.Profile?.UI_VNA_Trunk_Data?.Trunk_Group_Name} />
                    }

                    { // IP
                        configurationData.Profile?.UI_VNA_Trunk_Data?.Remote_CPU_1_IP_Address &&
                        <InputField label={getTranslated(dict, "PARAM_CPU_REMOTE_IP")}
                            defaultValue={configurationData.Profile?.UI_VNA_Trunk_Data?.Remote_CPU_1_IP_Address?.defaultValue}
                            regexp={configurationData.Profile?.UI_VNA_Trunk_Data?.Remote_CPU_1_IP_Address?.pattern}
                            handleChange={updateIP}
                            handleError={errorHandler}
                            validationPattern="IPv4"
                            value={trunkConfig?.Profile?.UI_VNA_Trunk_Data?.Remote_CPU_1_IP_Address} />
                    }
                </div>)
            }
        })()
        }

        {(() => {
            if (configurationData?.Profile?.UI_VNA_Master_Trunk_Data !== undefined) {
                return (<div>
                    <Divider className="sip-header" orientation="left" orientationMargin="0" plain style={{ borderColor: DARK_GRAY, }}>
                        {getTranslated(dict, "LABEL_UI_VNA_MASTER_TRUNK_DATA")}
                    </Divider>

                    { // Trunk name
                        configurationData?.Profile?.UI_VNA_Master_Trunk_Data?.Trunk_Group_Name &&
                        <InputField label={getTranslated(dict, "PARAM_TRUNK_GROUP_NAME")}
                            defaultValue={configurationData?.Profile?.UI_VNA_Master_Trunk_Data?.Trunk_Group_Name?.defaultValue}
                            regexp={configurationData?.Profile?.UI_VNA_Master_Trunk_Data?.Trunk_Group_Name?.pattern}
                            handleChange={updateMasterTrunkGroupName}
                            handleError={errorHandler}
                            value={trunkConfig?.Profile?.UI_VNA_Master_Trunk_Data?.Trunk_Group_Name} />
                    }

                    { // IP
                        configurationData.Profile?.UI_VNA_Master_Trunk_Data?.Remote_CPU_1_IP_Address &&
                        <InputField label={getTranslated(dict, "PARAM_CPU_REMOTE_IP")}
                            defaultValue={configurationData.Profile?.UI_VNA_Master_Trunk_Data?.Remote_CPU_1_IP_Address?.defaultValue}
                            regexp={configurationData.Profile?.UI_VNA_Master_Trunk_Data?.Remote_CPU_1_IP_Address?.pattern}
                            handleChange={updateMasterIP}
                            handleError={errorHandler}
                            validationPattern="IPv4"
                            value={trunkConfig?.Profile?.UI_VNA_Master_Trunk_Data?.Remote_CPU_1_IP_Address} />
                    }
                </div>)
            }
        })()
        }

        {(() => {
            if (configurationData?.Profile?.UI_VNA_Slave_Trunk_Data !== undefined) {
                return (<div>
                    <Divider className="sip-header" orientation="left" orientationMargin="0" plain style={{ borderColor: DARK_GRAY, }}>
                        {getTranslated(dict, "LABEL_UI_VNA_SLAVE_TRUNK_DATA")}
                    </Divider>

                    { // Trunk name
                        configurationData?.Profile?.UI_VNA_Slave_Trunk_Data?.Trunk_Group_Name &&
                        <InputField label={getTranslated(dict, "PARAM_TRUNK_GROUP_NAME")}
                            defaultValue={configurationData?.Profile?.UI_VNA_Slave_Trunk_Data?.Trunk_Group_Name?.defaultValue}
                            regexp={configurationData?.Profile?.UI_VNA_Slave_Trunk_Data?.Trunk_Group_Name?.pattern}
                            handleChange={updateSlaveTrunkGroupName}
                            handleError={errorHandler}
                            value={trunkConfig?.Profile?.UI_VNA_Slave_Trunk_Data?.Trunk_Group_Name} />
                    }

                    { // IP
                        configurationData.Profile?.UI_VNA_Slave_Trunk_Data?.Remote_CPU_1_IP_Address &&
                        <InputField label={getTranslated(dict, "PARAM_CPU_REMOTE_IP")}
                            defaultValue={configurationData.Profile?.UI_VNA_Slave_Trunk_Data?.Remote_CPU_1_IP_Address?.defaultValue}
                            regexp={configurationData.Profile?.UI_VNA_Slave_Trunk_Data?.Remote_CPU_1_IP_Address?.pattern}
                            handleChange={updateSlaveIP}
                            handleError={errorHandler}
                            validationPattern="IPv4"
                            value={trunkConfig?.Profile?.UI_VNA_Slave_Trunk_Data?.Remote_CPU_1_IP_Address} />
                    }
                </div>)
            }
        })()
        }
        <div className="sip-nav-buttons profile-span">
            <UMCButton
                className="sip-navigation-button sip-navigation-back sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_BACK")}
                type="primary"
                onClick={onPreviousPage}
                disabled={false} />
            <UMCButton
                className="sip-navigation-button sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_NEXT")}
                type="primary"
                onClick={validateFields}
                disabled={errorsOnPage !== 0} />
        </div>
        <CustomDialog
            title={title}
            open={isModalOpen}
            width={dlgType === "Error" ? "400px" : "500px"}
            footer={footer}
            type={dlgType}
            onCancel={handleCancel}
        >
            {message}
        </CustomDialog>
    </>);
}

export default VNATrunk;